import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import { IsoArt, ART } from './IsoArt';

const COPY = {
  es: {
    title: 'Cómo trabajamos',
    lead: 'Antes de la primera factura sabes qué vas a recibir y cuánto cuesta.',
    steps: [
      ['Diagnóstico', 'Una o dos reuniones, sin coste, para entender el problema con tus datos delante.'],
      ['Presupuesto cerrado', 'Precio y alcance de la primera fase, por escrito, antes de empezar.'],
      ['Entregas cada dos semanas', 'En cada entrega ves algo funcionando, y tienes acceso al código desde el primer día.'],
      ['Mantenimiento o traspaso', 'Seguimos nosotros con el mantenimiento, o te lo dejamos documentado para que lo lleve otro equipo.'],
    ],
  },
  en: {
    title: 'How we work',
    lead: 'From a pile of paper to a system that runs on its own, in four steps.',
    steps: [
      ['Diagnosis', 'One or two free meetings to understand the problem and look at your data.'],
      ['Fixed quote', 'Price and scope of the first phase, in writing, before the first invoice.'],
      ['Deliveries every two weeks', 'You see something working and we decide together what comes next. With access to the code from day one.'],
      ['Maintenance or handover', 'We stay on with you, or leave it documented so you can run it without us.'],
    ],
  },
};

export default function HowWeWork() {
  const { lang } = useTranslation();
  const c = COPY[lang] || COPY.es;

  return (
    <section id="como-trabajamos" className="section" aria-labelledby="como-title">
      <div className="wrap">
        <header className="sec-head">
          <h2 id="como-title" className="t-1">{c.title}</h2>
          <p className="t-lead">{c.lead}</p>
        </header>
        <ol className="steps">
          {c.steps.map(([name, text], i) => (
            <li key={name} className="step">
              <div className="step-art"><IsoArt {...ART[`step${i + 1}`]} s={15} /></div>
              <span className="step-n">{String(i + 1).padStart(2, '0')}</span>
              <h3 className="t-3">{name}</h3>
              <p>{text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
